import { render, staticRenderFns } from "./BasePageMenu.vue?vue&type=template&id=4b7ed3df&scoped=true"
import script from "./BasePageMenu.vue?vue&type=script&lang=js"
export * from "./BasePageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ed3df",
  null
  
)

/* custom blocks */
import block0 from "./BasePageMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports